import { useAuth as useClerkAuth, useUser } from '@clerk/clerk-react'

/**
 * Custom hook wrapper for Clerk authentication
 * Provides a clean interface for authentication throughout the app
 * Same return shape as the previous Kinde-based hook for backward compatibility
 */
export function useAuth() {
  const { isSignedIn, isLoaded, signOut, getToken } = useClerkAuth()
  const { user } = useUser()

  return {
    // User data
    user: user
      ? {
          id: user.id,
          email: user.primaryEmailAddress?.emailAddress,
          given_name: user.firstName,
          family_name: user.lastName,
        }
      : null,
    email: user?.primaryEmailAddress?.emailAddress,
    userId: user?.id,

    // Auth state
    isAuthenticated: isSignedIn ?? false,
    isLoading: !isLoaded,

    // Auth methods
    login: () => {
      window.location.href = '/auth/login'
    },
    register: () => {
      window.location.href = '/auth/register'
    },
    logout: () => signOut({ redirectUrl: '/' }),

    // Token management
    getAccessToken: async (): Promise<string | undefined> => {
      try {
        const token = await getToken()
        return token || undefined
      } catch {
        return undefined
      }
    },

    // Permissions (stub — configure via Clerk dashboard + organizations later)
    hasPermission: async (_permission: string): Promise<boolean> => false,
    hasRole: async (_role: string): Promise<boolean> => false,

    // Organization
    organization: null,
  }
}
